/**
 * Non-translatable structural data only.
 *
 * Every user-facing string lives in `src/i18n/locales/*.json`. Each entry below
 * carries an `id` that maps to its translation key, so components join the two.
 * Brand names stay here on purpose: they read the same in every locale, and
 * keeping them out of the locale files stops them being translated by mistake.
 */

export const heroLinks = {
  primaryCTA: "https://api.soroswap.finance/register",
  secondaryCTA: "https://docs.soroswap.finance"
};

export const trustedByPartners = [
  { id: "hot", name: "Hot Wallet", logo: "/images/partners/hot_logo.svg" },
  { id: "bim", name: "BIM.Finance", logo: "/images/partners/bim_logo.png", maxWidth: 260 },
  { id: "sodax", name: "Sodax", logo: "/images/partners/sodax_logo.svg" },
  { id: "decaf", name: "Decaf", logo: "/images/partners/decaf_logo.svg" },
  { id: "socketfi", name: "Socket.fi", logo: "/images/partners/socketfi_logo.svg" }
];

export const apiFeatures = [
  { id: "rest", icon: "api" },
  { id: "routing", icon: "routing" },
  { id: "integration", icon: "clock" },
  { id: "gasless", icon: "gasless" }
];

export const ctaLinks = [
  { id: "apiKey", href: "https://api.soroswap.finance/register" },
  { id: "discord", href: "https://discord.gg/A2rQ3cm9XG" }
];

// The founders' shared booking calendar, behind a redirect on paltalabs.io (paltalabs/landing-page vercel.json).
export const bookCallUrl = "https://paltalabs.io/cal";

export const liquiditySources = [
  { id: "soroswap", name: "Soroswap AMM", logo: "/images/partners/soroswap_logo.svg" },
  { id: "aquarius", name: "Aquarius", logo: "/images/aqua_logo.svg" },
  { id: "sushi", name: "Sushi", logo: "/images/sushi_logo.svg" },
  { id: "comet", name: "Comet", logo: "/images/comet_logo.svg" },
  { id: "stellarClassic", name: "Stellar Classic", logo: "/images/stellar_logo.svg" }
];

export const earnLink = "https://app.soroswap.finance/earn";

export const developerResources = [
  { id: "docs", icon: "docs", href: "https://docs.soroswap.finance" },
  { id: "github", icon: "github", href: "https://github.com/soroswap" },
  { id: "discord", icon: "discord", href: "https://discord.gg/A2rQ3cm9XG" }
];

export const strategicPartners = [
  { id: "defindex", name: "DeFindex", logo: "/images/defindex_logo.svg" },
  { id: "aquarius", name: "Aquarius", logo: "/images/aqua_logo.svg" },
  { id: "stellar", name: "Stellar Development Foundation", logo: "/images/stellar_logo.svg" }
];

// Tab order is intentional and drives the rendered order of the App section.
export const discoverAppTabs = [
  {
    id: "api",
    href: "https://docs.soroswap.finance",
    image: "/images/preview/api-preview.webp",
    icon: "{ }"
  },
  {
    id: "swap",
    href: "https://app.soroswap.finance",
    image: "/images/preview/swap-preview.webp",
    icon: "🔄"
  },
  {
    id: "earn",
    href: "https://app.soroswap.finance/earn",
    image: "/images/preview/earn-preview.webp",
    icon: "📈"
  },
  {
    id: "bridge",
    href: "https://app.soroswap.finance/bridge",
    image: "/images/preview/bridge-preview.webp",
    icon: "🌉"
  },
  {
    id: "pools",
    href: "https://app.soroswap.finance/liquidity",
    image: "/images/preview/pools-preview.webp",
    icon: "💧"
  }
];

export const faqIds = [
  "whatIsSoroswap",
  "pricing",
  "whoUsesIt",
  "integrationTime",
  "appVsApi",
  "bridging",
  "earn"
];

export const discordInviteUrl = "https://discord.gg/A2rQ3cm9XG";
